import React from 'react';

/* eslint-disable max-len */
const ShoppingLogoMobileMini = _ref => {
  let {
    className,
    title
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1453.97 130.9",
    className: className
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, '.cls-1{fill:none;}.cls-1,.cls-2,.cls-3{stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:4.39px;}.cls-2{fill:#fff;}.cls-3{fill:#f3797b;}')), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.25,29.47V21C76.25,8.59,65.12.33,51.38,2.56S26.51,16.65,26.51,29.06V39.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "2.2 45.7 10.51 50.37 18.82 42.39 27.14 47.06 35.45 39.08 43.76 43.75 52.08 35.77 60.39 40.44 68.7 32.46 77.02 37.13 85.33 29.16 91.71 33.82 91.71 128.71 3.22 121.13 2.2 45.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "115.4 34.75 108.73 38.89 106.06 32.09 100.55 36.42 97.22 29.16 91.71 33.37 91.71 128.71 115.4 119.65 115.4 34.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Arrow",
    points: "76.25 80.77 72.44 53.71 47.09 63.94 57.14 69.74 47.65 86.17 31.21 76.68 15.02 104.73 24.09 109.97 35.05 90.99 51.48 100.48 66.21 74.97 76.25 80.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.35,114.52v-74h33c12.86,0,20.74,7.77,20.74,18.86,0,9.32-6.21,15.53-13,17,7.87,1.22,14.42,9.32,14.42,18.2,0,11.86-7.87,20-21.41,20Zm44.15-53.8c0-6.65-4.44-12-12.75-12H164.56V72.59h22.19C195.06,72.59,199.5,67.49,199.5,60.72Zm1.44,32.84c0-6.77-4.66-12.76-13.75-12.76H164.56v25.51h22.63C195.84,106.31,200.94,101.43,200.94,93.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.67,85.79V40.53h9.21v45c0,13.53,7.32,22.07,21,22.07s21-8.54,21-22.07v-45H301V85.68c0,18.41-10.1,30.17-30.17,30.17S240.67,104,240.67,85.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.54,114.52v-7.65l41.59-58.13H330.54V40.53H383.9v7.66l-41.6,58.12h42.37v8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,114.52v-7.65l41.59-58.13H411V40.53h53.35v7.66l-41.6,58.12h42.38v8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.74,114.52v-74h48.47v8.21H504V72.59h38.49V80.8H504v33.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.29,114.52v-74h48.48v8.21H580.5V72.59H619V80.8H580.5v25.51h39.27v8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650,114.52v-74h48.47v8.21H659.16V72.59h38.49V80.8H659.16v25.51h39.27v8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.61,114.52v-74H753.9c23,0,37.94,16.09,37.94,37.05s-15,36.94-37.94,36.94ZM782.3,77.58c0-16-10.1-28.84-28.4-28.84H737.82v57.57H753.9C771.87,106.31,782.3,93.44,782.3,77.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.49,104.09l8.54-12a32.44,32.44,0,0,0,23.52,10c8.65,0,12.86-4,12.86-8.21,0-13.09-42.59-4.1-42.59-31.95,0-12.31,10.65-22.52,28.06-22.52,11.76,0,21.52,3.55,28.84,10.32L866,61.28a31.77,31.77,0,0,0-21.52-8.1c-6.77,0-10.54,3-10.54,7.43,0,11.76,42.49,3.88,42.49,31.5,0,13.54-9.66,23.74-29.62,23.74C832.57,115.85,822.36,111.08,815.49,104.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.73,114.52V83.46h-35v31.06H899v-74h15.75V69.6h35V40.53h15.86v74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.56,77.58c0-22.29,16.31-38.27,38.61-38.27s38.71,16,38.71,38.27-16.31,38.27-38.71,38.27S988.56,99.88,988.56,77.58Zm61.13,0c0-13.86-8.88-24.29-22.52-24.29s-22.41,10.43-22.41,24.29,8.76,24.3,22.41,24.3S1049.69,91.34,1049.69,77.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089,114.52v-74h34.61c16.08,0,24.85,10.87,24.85,23.85s-8.88,23.85-24.85,23.85h-18.86v26.29Zm43.38-50.14c0-6.21-4.67-10-10.88-10h-16.75v20h16.75C1127.68,74.37,1132.35,70.48,1132.35,64.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.18,114.52v-74h34.62c16.08,0,24.84,10.87,24.84,23.85s-8.87,23.85-24.84,23.85h-18.86v26.29Zm43.38-50.14c0-6.21-4.66-10-10.88-10h-16.74v20h16.74C1208.9,74.37,1213.56,70.48,1213.56,64.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.4,114.52v-74h15.75v74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.81,114.52l-35.28-48.25v48.25h-15.75v-74H1310L1344.26,87V40.53H1360v74Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1383.09,77.58c0-23.4,17.75-38.27,39.38-38.27,15.42,0,25.07,7.77,30.62,16.53L1440,62.94a21,21,0,0,0-17.53-9.65c-13.42,0-23.18,10.32-23.18,24.29s9.76,24.3,23.18,24.3c6.55,0,12.76-2.89,15.76-5.66V87.34H1418.7V73.59H1454V102a41,41,0,0,1-31.5,14C1400.84,116,1383.09,100.88,1383.09,77.58Z"
  }))));
};

export { ShoppingLogoMobileMini };
